import '../../../Osc.Common/Frontend/styles/views.login.scss';
import '../../../Osc.Common/Frontend/styles/main.scss';
import '../styles/trumps.scss';

// Import Vue dependencies
import Vue from 'vue';

// Import the Vue components we created
import ResetPassword from '../../../Osc.Common/Frontend/passwords/resetpassword.vue';

$(document).ready(function () {
    // Check if reset password container exists on the page
    const container = document.getElementById('reset-password-container');
    if (container) {
        // Extract data from container data attributes (set by Razor view)
        const userId = container.dataset.userId;
        const code = container.dataset.code;
        const isExpired = container.dataset.isExpired === 'true';

        console.log('Extracted from container - userId:', userId, 'code:', code, 'isExpired:', isExpired);

        // Validate required props
        if (!userId || !code) {
            console.error('ResetPassword component requires userId and code props');
            container.innerHTML = '<div class="error">Invalid reset password link. Please request a new password reset.</div>';
            return;
        }

        // Mount Vue component with props
        new Vue({
            render: h => h(ResetPassword, {
                props: { 
                    userId: userId,
                    code: decodeURIComponent(code),
                    isExpired: isExpired
                }
            }),
        }).$mount('#reset-password-container');
    }
});